// -*- js-indent-level: 4; -*-
var sticky;

const $ = jQuery.noConflict();

jQuery(document).ready(function () {
  $("article")
    .on("click", ".wp-caption:not(:target)", function () {
      document.location.hash = "#" + this.id;
    })
    .on("click", ".wp-caption:target", function () {
      let id = $(this).find(".wp-caption-text").attr("id") || "closed";
      document.location.hash = "#" + id;
    });

  /*
    Show Finanztrends ad

    The script from Finanztrends waits for DOMContentLoaded, but the it is
    inserted by our adserver too late, so its functional code does not run. Here
    we trigger the event again. Fingers crossed this does not have any side
    effects..
  */
  /* this causes adinserter to insert its code-blocks twice
  setTimeout(function () {
    if (typeof customParameters != "undefined") {
      console.debug("trigger DOMContentLoaded for ft");
      document.dispatchEvent(new Event("DOMContentLoaded"));
    }
  }, 5000);
  */
});
